import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "antd";

import { translate } from "@/core/i18n/lookup";
import { usePreferences } from "@/core/state/preferences";

interface BoundaryProps { children: ReactNode }
interface BoundaryState { failed: boolean }

export class PageErrorBoundary extends Component<BoundaryProps, BoundaryState> {
  state: BoundaryState = { failed: false };

  static getDerivedStateFromError(): BoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("portal.page.render_failed", error.name, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <BoundaryFallback onRetry={() => this.setState({ failed: false })} />;
  }
}

function BoundaryFallback({ onRetry }: { onRetry: () => void }) {
  const locale = usePreferences((state) => state.locale);
  return (
    <div className="boot-screen boot-error">
      <div>
        <h1>{translate(locale, "errors.boundaryTitle")}</h1>
        <p>{translate(locale, "errors.boundaryHint")}</p>
        <Button type="primary" onClick={onRetry}>{translate(locale, "errors.retry")}</Button>
      </div>
    </div>
  );
}
